import script from "./receipt-info.vue?vue&type=script&setup=true&lang=ts"
export * from "./receipt-info.vue?vue&type=script&setup=true&lang=ts"

import "./receipt-info.vue?vue&type=style&index=0&id=f045b08e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f045b08e"]])

export default __exports__